module.exports = __webpack_public_path__ + "media/evolve/assets/icons/planned/sorry-f5fdec9d5c68d05d06058d9aa3a93803.svg";